module.exports = __webpack_public_path__ + "static/portfolio-7b201e5760c93c15e075ec6a83f49acc.svg";